import {Component, ElementRef, OnInit, Renderer, ViewChild} from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import {AccessControlService} from 'src/app/services/access-control.service';
import {MatPaginator, MatTableDataSource, MatSort} from '@angular/material';
import {catchError, map, startWith, switchMap, tap} from 'rxjs/operators';
import { UserListingComponent } from '../access-control/user-listing/user-listing.component';
import { environment } from 'src/environments/environment';
import { MatDatepicker } from '@angular/material/datepicker';
import { AuthService } from '../services/auth.service';
@Component({
  selector: 'app-user-logs',
  templateUrl: './user-logs.component.html',
  styleUrls: ['./user-logs.component.css']
})
export class UserLogsComponent implements OnInit {
  status: any;
  selectedApp: String;
  selectedAppName:String;
  roleName: any;
  constructor(
              private accessControlService: AccessControlService,
              private activatedRoute: ActivatedRoute,
              private authService:AuthService) {
              UserListingComponent.app_id = this.activatedRoute.snapshot.params['id'];
    this.org_id = localStorage.getItem('org_id');
  }

  static app_id: any;
  filterByActivity:"NOT_LOGGED_IN" | "LOGGED_IN" | ""="NOT_LOGGED_IN" ;
  showCols:String=this.filterByActivity;
  userList: any = [];
  org_id: any;
  displayedColumns: string[] = ['firstname', 'email_id', 'loginDate', 'applicationName','roles','platform'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('input') input: ElementRef;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('picker2') picker2!: MatDatepicker<Date>;
  isLoading: boolean;
  dataSource = new MatTableDataSource<any>();
  defaultPageNumber = 1;
  defaultPageSize = 10;
  statusFilter = '';
  userNameFilter=''
  endDate=new Date();
  today = new Date(); // Current date
  startDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 7);
  statusOptions:Array<String> = ["ACTIVATED", "DE-ACTIVATED", "LOCKED", "SUSPENDED",'NOT-LOGGEDIN'];
  statusInfo = [{state: 'ACTIVATED', count: 0}, {state: 'DE-ACTIVATED', count: 0}, {
    state: 'Suspended',
    count: 0
  }, {state: 'Locked', count: 0}];
  isLoadingStats = false;
  totalRecords:number
  displayFilter:"viewLatest"|""|null=null;
  maxDate:Date=new Date();
  minDate:Date= new Date();
  clientApps:any;
  appId:String;
  rolesList:Array<any> ;
  selectedRoleId:String=null;
  selectedRoleName:String=null;
  ngOnInit() {
   this.getClientApps();
  }
  loadData() {
    this.isLoading=true
    this.getTableData(  this.paginator.pageIndex +1,
      this.paginator.pageSize ,
      this.statusFilter,
      this.startDate,
      this.endDate,
      this.userNameFilter,
      this.displayFilter,)
  }
  getTableData(pageNumber: number = 1, pageSize: number = 10, status, startDate, endDate, userName, displayFilter) {
    this.accessControlService.getUserLogs(this.org_id, this.appId, this.selectedRoleId, this.selectedRoleName, this.filterByActivity, pageNumber, pageSize, status, startDate, endDate, userName, displayFilter)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.error) {
            return;
          }
          this.showCols = this.filterByActivity;
          this.selectedAppName = this.selectedApp; //only update app name on ui when we get response
          const tbData = res.logs && res.logs.length > 0 ? res.logs[0].data : []; // Check if logs exist before accessing properties
          this.totalRecords = res.logs[0].noOfRecords;
          this.dataSource = new MatTableDataSource(tbData);
        },
        (err: any) => {
          if (err) {
            this.isLoading = false;
          }
        }
      );
  }


  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.paginator.page
			.pipe(
				tap(() => {
          this.isLoading=true;
					return  this.getTableData(  this.paginator.pageIndex +1,
            this.paginator.pageSize ,
            this.statusFilter,
            this.startDate,
            this.endDate,
            this.userNameFilter,
            this.displayFilter,);
				})
			)
			.subscribe();

  }


  applyFilter(event: Event) {
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  searchFilters() {
   this.loadData()
  }

  downloadReport(fileType:string) {
    const fileUrl = `${environment.serverUrl}access-control/login-reports/${this.org_id}/${this.appId}/${this.selectedRoleId}?pageIndex=&pageSize=&status=${this.statusFilter}&startDate=${this.startDate}&endDate=${this.endDate}&userName=${this.userNameFilter}&genrateFile=true&fileType=${fileType}&viewLatest=${this.displayFilter}&activity=${this.filterByActivity}` ;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.click();

  }
  resetFilters() {

    this.displayFilter='';
    this.userNameFilter='';
    this.startDate=new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 7);
    this.endDate=new Date();
    this.statusFilter='';
    this.appId=this.clientApps[0]._id;
    this.selectedApp=this.clientApps[0].application_name;
    this.paginator.pageIndex=0;
    // this.filterByActivity='NOT_LOGGED_IN';
    this.selectedRoleId=null;
    this.selectedRoleName='';
    this.loadData();
  }
  openDatePicker(datePicker: MatDatepicker<Date>): void {
    datePicker.open();
  }
  getClientApps(){
    this.accessControlService.getClientAppsWithMinDetails(this.org_id).
      subscribe({
        next:(res:any)=> {
          if(res.error){
            console.log(res.message)
            return;
          }
          this.clientApps=res.data.applications;
          this.appId=this.clientApps[0]._id;
          this.selectedApp=this.clientApps[0].application_name;
          this.getSelectedApp(this.appId);
          this.loadData();
          console.log(this.clientApps)

        },
        error:(err)=> {
          if(err){
            console.log(err.message)
          }
        },
      })
  }
  getSelectedApp(appId:String=''){
    this.selectedApp=this.clientApps.find(v=>v._id==appId).application_name
    //get app roles
    this.authService.listRolesOfClientForApplication(this.appId,this.org_id).subscribe((roles:any)=>{
      this.rolesList=roles;
    },
    (err:any)=>{
      console.log(err.message)
    })
  }
  saveRoleName(){
    const role= this.rolesList.find(roleObj=>this.selectedRoleId==roleObj._id);
    this.selectedRoleName = role ? role.name : ""
    console.log(this.selectedRoleName)
  }
  resetPaginator(){
    this.paginator.pageIndex=0;
    this.paginator.pageSize=10;
    this.resetFilters();
  }
}
function observableOf(arg0: null): import("rxjs").ObservableInput<unknown> {
  throw new Error('Function not implemented.');
}

